var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import { ThemeProvider } from '@mui/material/styles';
import theme from '../theme';
var Notification = function (props) {
    var _a = React.useState(props.isOpen !== undefined ? props.isOpen : true), open = _a[0], setOpen = _a[1];
    var handleClick = function () {
        setOpen(true);
    };
    var handleClose = function (event, reason) {
        if (reason === 'clickaway') {
            return;
        }
        setOpen(false);
        if (props.actions.onClose) {
            props.actions.onClose();
        }
    };
    return _jsx(ThemeProvider, __assign({ theme: theme }, { children: _jsx(Snackbar, __assign({ anchorOrigin: { vertical: "top", horizontal: "center" }, open: open, autoHideDuration: props.durationInMS || 15000, onClose: handleClose }, { children: _jsx(Alert, __assign({ color: props.severity, severity: props.severity, onClose: handleClose, variant: "standard", sx: {
                    "& .MuiAlert-icon": {
                        color: "white"
                    }
                } }, { children: props.message }), "".concat(props.key, "-alert")) }), "".concat(props.key, "-snackbar")) }));
};
export default Notification;
